import { mp3Importer } from "./moduleImporter";

//Background musics
import bgm_lobby from "../assets/mp3/bg_music.mp3";

//Sound effects
import sfx_bet from "../assets/mp3/bet.mp3";
import sfx_clear from "../assets/mp3/clear.mp3";
import sfx_click from "../assets/mp3/click.mp3";
import sfx_countdown from "../assets/mp3/countdown.mp3";
import sfx_game_start from "../assets/mp3/game_start.mp3";
import sfx_rebet from "../assets/mp3/rebet.mp3";
import sfx_youwon from "../assets/mp3/youwon.mp3";

import sfx_open_bet from "../assets/mp3/open_bet.mp3";
import sfx_close_bet from "../assets/mp3/close_bet.mp3";

//Baccarat voice files
import sfx_banker_win from "../assets/mp3/baccarat/banker_win.mp3";
import sfx_player_win from "../assets/mp3/baccarat/player_win.mp3";
import sfx_tie_game from "../assets/mp3/baccarat/tie_game.mp3";
import sfx_card_open from "../assets/mp3/baccarat/card_open.mp3";

//Dragon & Tiger voice files
import sfx_dragon_win from "../assets/mp3/baccarat/dragon_win.mp3";
import sfx_tiger_win from "../assets/mp3/baccarat/tiger_win.mp3";

import Desktop from "@/components/Desktop";
import MobileGame from "@/components/MobileGame";

//Todo: define Sound typedefs

type GameContainerClassType = Desktop | MobileGame;

export interface IAudioMethods {
	// Setter: commonSounds > bindCommonSounds()
	// Sound-related types
	playBetSFX: () => void;
	playClearSFX: () => void;
	playRebetSFX: () => void;
	playClickSFX: () => void;
	playBGM: () => void;
	playedBGM: boolean;
	playGameStartSFX: () => void;
	playOpenBetSFX: () => void;
	playYouWonSFX: () => void;
}

export interface IAudioFiles {
	bgmLobby: HTMLAudioElement;

	sfxYouWon: HTMLAudioElement;
	sfxBet: HTMLAudioElement;
	sfxClear: HTMLAudioElement;
	sfxClick: HTMLAudioElement;
	sfxCountdown: HTMLAudioElement;
	sfxGameStart: HTMLAudioElement;
	sfxRebet: HTMLAudioElement;
	sfxOpenBet: HTMLAudioElement;
	sfxCloseBet: HTMLAudioElement;

	// Baccarat
	baccarat_voice_array: HTMLAudioElement[];
	sfxBankerWin: HTMLAudioElement;
	sfxPlayerWin: HTMLAudioElement;
	sfxTieGame: HTMLAudioElement;
	sfxCardOpen: HTMLAudioElement;

	banker_result_voice_array: HTMLAudioElement[];
	player_result_voice_array: HTMLAudioElement[];
	tie_result_voice_array: HTMLAudioElement[];

	// Dragon & Tiger
	sfxDragonWin: HTMLAudioElement;
	sfxTigerWin: HTMLAudioElement;

	dragon_result_voice_array: HTMLAudioElement[];
	tiger_result_voice_array: HTMLAudioElement[];
}


/**
 * Generic Audio Element player.
 * @param soundVolume Range: 0-100
 */
function playSound(soundObj: HTMLAudioElement, soundVolume: number) {
	if (!soundObj || isNaN(soundVolume)) return;

	try {
		soundObj.volume = soundVolume / 100;
		const playPromise = soundObj.play();

		if (playPromise) {
			playPromise.then(() => {
				// Automatic playback
			}).catch(err => {
				console.error(err);
			});
		}
	} catch (ex) {
		console.warn(ex);
	}
}


//Import functions
function importCommonSFX(mainClass: GameContainerClassType) {
	//Sound Note: add these for the mp3 import
	mainClass.sfxYouWon = new Audio(sfx_youwon);

	mainClass.sfxBet = new Audio(sfx_bet);
	mainClass.sfxClear = new Audio(sfx_clear);
	mainClass.sfxClick = new Audio(sfx_click);
	mainClass.sfxCountdown = new Audio(sfx_countdown);
	mainClass.sfxGameStart = new Audio(sfx_game_start);
	mainClass.sfxRebet = new Audio(sfx_rebet);

	mainClass.sfxOpenBet = new Audio(sfx_open_bet);
	mainClass.sfxCloseBet = new Audio(sfx_close_bet);
}

function importCommonBGM(mainClass: GameContainerClassType) {
	//Initialise sound files
	mainClass.playedBGM = false;
	mainClass.bgmLobby = new Audio(bgm_lobby);
}

function importBaccaratVoiceFiles(mainClass: GameContainerClassType) {
	mainClass.baccarat_voice_array = mp3Importer("baccarat");

	mainClass.sfxBankerWin = new Audio(sfx_banker_win);
	mainClass.sfxPlayerWin = new Audio(sfx_player_win);
	mainClass.sfxTieGame = new Audio(sfx_tie_game);
	mainClass.sfxCardOpen = new Audio(sfx_card_open);

	mainClass.banker_result_voice_array = mp3Importer("baccarat_banker");
	mainClass.player_result_voice_array = mp3Importer("baccarat_player");
	mainClass.tie_result_voice_array = mp3Importer("baccarat_tie");
}

function importDragonTigerVoiceFiles(mainClass: GameContainerClassType) {
	mainClass.sfxDragonWin = new Audio(sfx_dragon_win);
	mainClass.sfxTigerWin = new Audio(sfx_tiger_win);

	mainClass.dragon_result_voice_array = mp3Importer("dragon_tiger_dragon");
	mainClass.tiger_result_voice_array = mp3Importer("dragon_tiger_tiger");
}


function bindCommonSounds(this: GameContainerClassType) {
	this.playBGM = playBGM.bind(this);

	this.playBetSFX = playBetSFX.bind(this);
	this.playClearSFX = playClearSFX.bind(this);
	this.playRebetSFX = playRebetSFX.bind(this);

	if (this instanceof Desktop)
		this.playClickSFX = playClickSFX.bind(this);

	this.playGameStartSFX = playGameStartSFX.bind(this);
	this.playOpenBetSFX = playOpenBetSFX.bind(this);
	this.playYouWonSFX = playYouWonSFX.bind(this);
	this.playCardOpenSFX = playCardOpenSFX.bind(this);
	this.playCloseBetSFX = playCloseBetSFX.bind(this);
	this.playCountdownSFX = playCountdownSFX.bind(this);

	//Baccarat special
	// mainclass.playPlayerVoice = playPlayerVoice.bind(mainclass);
	// mainclass.playBankerVoice = playBankerVoice.bind(mainclass);
	this.playTieVoice = playTieVoice.bind(this);

	this.playWinVoice = playWinVoice.bind(this);

	//Dragon & Tiger special
	// mainclass.playDragonVoice = playDragonVoice.bind(mainclass);
	// mainclass.playTigerVoice = playTigerVoice.bind(mainclass);
}

function disposeCommonSounds(mainClass: GameContainerClassType) {
	const functionList = [
		"playBGM",

		"playBetSFX",
		"playClearSFX",
		"playRebetSFX",

		"playClickSFX",

		"playGameStartSFX",
		"playOpenBetSFX",
		"playYouWonSFX",
		"playCardOpenSFX",
		"playCloseBetSFX",
		"playCountdownSFX",

		"playTieVoice",
		"playWinVoice",
	];

	// console.log("dCS", functionList);

	for (const name of functionList)
		delete mainClass[name];
}


//Play functions
//Plays BGM and lööps it
function playBGM() {
	if (!this.state.enableMusic) return;

	try {
		this.bgmLobby.addEventListener("ended", function () {
			this.currentTime = 0;
			this.play();
		}, false);

		this.bgmLobby.play();
	} catch (ex) {
		console.warn(ex);
	}
}


//Play Sound Effects starts here
function playBetSFX() {
	if (!this.state.enableSound) return;
	playSound(this.sfxBet, this.state.soundVolume);
}

function playCardOpenSFX() {
	if (!this.state.enableSound) return;
	playSound(this.sfxCardOpen, this.state.soundVolume);
}

function playClearSFX() {
	if (!this.state.enableSound) return;
	playSound(this.sfxClear, this.state.soundVolume);
}

function playClickSFX() {
	if (!this.state.enableSound) return;
	playSound(this.sfxClick, this.state.soundVolume);
}

function playCloseBetSFX() {
	if (!this.state.enableSound) return;
	playSound(this.sfxCloseBet, this.state.soundVolume);
}

function playCountdownSFX() {
	if (!this.state.enableSound) return;
	playSound(this.sfxCountdown, this.state.soundVolume);
}

function playGameStartSFX() {
	if (!this.state.enableSound) return;
	playSound(this.sfxGameStart, this.state.soundVolume);
}

function playOpenBetSFX() {
	if (!this.state.enableSound) return;
	playSound(this.sfxOpenBet, this.state.soundVolume);
}

function playRebetSFX() {
	if (!this.state.enableSound) return;
	playSound(this.sfxRebet, this.state.soundVolume);
}

function playYouWonSFX() {
	if (!this.state.enableSound) return;
	playSound(this.sfxYouWon, this.state.soundVolume);
}

// Baccarat
function playBankerVoice(mainClass: GameContainerClassType, num: number) {
	if (!mainClass.state.enableSound) return;

	playSound(
		mainClass.banker_result_voice_array[`banker_${num}`],
		mainClass.state.soundVolume
	);
}

function playPlayerVoice(mainClass: GameContainerClassType, num: number) {
	if (!mainClass.state.enableSound) return;

	playSound(
		mainClass.player_result_voice_array[`player_${num}`],
		mainClass.state.soundVolume
	);
}

//Dragon & Tiger
function playDragonVoice(mainClass: GameContainerClassType, num: number) {
	if (!mainClass.state.enableSound) return;

	playSound(
		mainClass.dragon_result_voice_array[`dragon_${num}`],
		mainClass.state.soundVolume
	);
}

function playTigerVoice(mainClass: GameContainerClassType, num: number) {
	if (!mainClass.state.enableSound) return;

	playSound(
		mainClass.tiger_result_voice_array[`tiger_${num}`],
		mainClass.state.soundVolume
	);
}

function playTieVoice(num: number) {
	if (!this.state.enableSound) return;

	playSound(
		this.tie_result_voice_array[`tie_${num}`],
		this.state.soundVolume
	);
}

function playWinVoice(who: string) {
	if (!this.state.enableSound) return;

	switch (who) {
		// Baccarat
		case "banker":
			playSound(this.sfxBankerWin, this.state.soundVolume);
			break;
		case "player":
			playSound(this.sfxPlayerWin, this.state.soundVolume);
			break;
		case "tie":
			playSound(this.sfxTieGame, this.state.soundVolume);
			break;

		// Dragon & Tiger
		case "dragon":
			playSound(this.sfxDragonWin, this.state.soundVolume);
			break;
		case "tiger":
			playSound(this.sfxTigerWin, this.state.soundVolume);
			break;
	}
}

export {
	importCommonSFX,
	importCommonBGM,

	bindCommonSounds,
	disposeCommonSounds,

	importBaccaratVoiceFiles,
	importDragonTigerVoiceFiles,

	//BGM
	playBGM,

	//SFX
	playBetSFX,
	playCardOpenSFX,
	playClearSFX,
	playClickSFX,
	playCloseBetSFX,
	playCountdownSFX,
	playGameStartSFX,
	playOpenBetSFX,
	playRebetSFX,
	playYouWonSFX,

	//Baccarat voice
	playPlayerVoice,
	playBankerVoice,

	//Dragon & tiger voice
	playDragonVoice,
	playTigerVoice
};